import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSuperadminAuth } from '../contexts/SuperadminAuthContext';
import { SUPERADMIN_ROUTES } from './routes';

export const SuperadminHomeRedirect: React.FC = () => {
  const { isAuthenticated, loading } = useSuperadminAuth();

  // Show nothing while checking auth
  if (loading) {
    return null;
  }

  // Redirect based on authentication status
  if (isAuthenticated) {
    return <Navigate to={SUPERADMIN_ROUTES.DASHBOARD} replace />;
  }

  return <Navigate to={SUPERADMIN_ROUTES.LOGIN} replace />;
};

